class SearchInputField {
  onKeyUp(typedValue) {
    this.inputChanged({ typedValue });
  }
}

export default SearchInputField;
